import { put, takeEvery } from "redux-saga/effects";
import { createAction } from "redux-actions";

export const UPDATE_DATE = "saga/UPDATE_DATE";
export const UPDATE_DATE_SUCCESS = "saga/UPDATE_DATE_SUCCESS";

export const actionCreators = {
  updateDate: createAction(UPDATE_DATE)
};

export default function* watchStars() {
  yield takeEvery(UPDATE_DATE, updateDate);
}

export function* updateDate(data) {
  yield put({ type: UPDATE_DATE_SUCCESS, payload: data.payload });
}
